import OSS from 'ali-oss';

let util = {
    channels: [],
    getSts() {
        return new Promise((resolve, reject) => {
            Util.ajax.get(Util.api.get_sts)
                .then(res => res.data)
                .then(res => {
                    if(res.code === 0) {
                        resolve(res.data)
                    } else {
                        reject()
                    }
                })
                .catch(e => {
                    reject(e)
                })
        });
    },
    getPledgeTags() {
        return new Promise((resolve, reject) => {
            Util.ajax.get(Util.api.mall_pledge_tags_list)
            .then(res => res.data)
            .then(res => {
                if(res.code === 1) {
                    resolve(res.data)
                }
            })
            .catch(e => {
                reject(e);
            })
        });
    },
    getOSSClient(options) {
        const { accessKeyId, accessKeySecret, stsToken, bucket} = options;
        return new OSS({
            region: 'oss-cn-hangzhou',
            bucket: bucket || 'fullfilment-center',
            accessKeyId,
            accessKeySecret,
            stsToken
        })
    },
    getUploadPath(file) {
        const extension = file.name.split('.').pop()
        const prefix = '/rc201603281546/video/items/m/uploads';
        const fileName = new Date().getTime().toString();
        return `${prefix}/${fileName}.${extension}`;
    },
    getChannelList() {
        return new Promise((resolve, reject)=>{
            Util.ajax.get(Util.api.mall_channel_list).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    resolve(res.data);
                }else{
                    reject({message: res.msg});
                }
            }).catch((e)=>{
                reject(e);
            });
        });
    },
    getMallOnlineItemEditInfo(id) {
        return new Promise((resolve, reject)=>{
            Util.ajax.get(Util.api.mall_online_item_edit_info, {
                params: {
                    id: id
                }
            }).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    resolve(res.data);
                }else{
                    reject({message: res.msg});
                }
            }).catch((e)=>{
                reject(e);
            });
        });
    },
    getMallOnlineItemDetail(id) {
        return new Promise((resolve, reject)=>{
            Util.ajax.get(Util.api.mall_online_item_detail, {
                params: {
                    id: id
                }
            }).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    resolve(res.data);
                }else{
                    reject({message: res.msg});
                }
            }).catch((e)=>{
                reject(e);
            });
        });
    },
    getMallItemDiffInfo(id) {
        return new Promise((resolve, reject)=>{
            Util.ajax.get(Util.api.mall_item_diff_info, {
                params: {
                    id: id
                }
            }).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    resolve(res.data);
                }else{
                    reject({message: res.msg});
                }
            }).catch((e)=>{
                reject(e);
            });
        });
    },
    delOnlineItem(id) {
        return new Promise((resolve, reject)=>{
            Util.ajax.post(Util.api.del_mall_online_item, {
                id: id
            }).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    resolve(res.data);
                }else{
                    reject({message: res.msg});
                }
            }).catch((e)=>{
                reject(e);
            });
        });
    }
};

// 渠道
util.channels = [
    {value: 100, label: '百词斩APP'},
    {value: 200, label: '商城'},
    {value: 300, label: '薄荷阅读'},
    {value: 400, label: '蛋糕英语'},
    {value: 600, label: '番茄英语'},
    {value: 700, label: '芝士派'},
    {value: 800, label: '咸蛋口语'},
    {value: 1100, label: '芝士小考'},
    {value: 1300, label: '夜曲编程'},
    {value: 1400, label: '柚子鸭'},
    {value: 1600, label: '薄荷生活'},
    {value: 1700, label: '爱阅读'},
    {value: 1900, label: '电商团队'},
];
const channel_hash = Object.assign(...util.channels.map(obj => ({ [obj.value]: obj.label })));
util.getChannelName = (channel_id) => {
    if (channel_id) {
        const name = channel_hash[channel_id];
        return name ? name : '未定义渠道';
    } else {
        return '-';
    }
};
// 品类
util.categories = [
    {value: 3, label: '周边文具'},
    {value: 1, label: '读物'},
    {value: 2, label: '备考'},
    {value: 5, label: '生活'},
    // {value: 4, label: '斩家课程'},
];
const categories_hash = Object.assign(...util.categories.map(obj => ({ [obj.value]: obj.label })));
util.getCategoryName = (category_id) => {
    const name = categories_hash[category_id];
    return name ? name : '未定义品类';
};

// 展示类型
util.show_types = [
    {value: 0, label: '正常'},
    {value: 1, label: '隐藏'},
];
const show_types_hash = Object.assign(...util.show_types.map(obj => ({ [obj.value]: obj.label })));
util.getShowTypeName = (show_type_id) => {
    const name = show_types_hash[show_type_id];
    return name ? name : '未定义展示类型';
};

// 类别
util.item_types = [
    {value: 0, label: '实体商品'},
    {value: 1, label: '虚拟商品'},
];
const item_types_hash = Object.assign(...util.item_types.map(obj => ({ [obj.value]: obj.label })));
util.getItemTypeName = (item_type_id) => {
    const name = item_types_hash[item_type_id];
    return name ? name : '未定义类别';
};

// 状态
util.statuses = [
    {value: 1, label: 'ONLINE', color_class: 'color-success'},
    {value: 0, label: 'OFFLINE', color_class: 'color-grey'},
    {value: -1, label: 'REMOVED', color_class: 'color-error'},
];
const statuses_hash = Object.assign(...util.statuses.map(obj => ({ [obj.value]: obj.label })));
util.getStatusName = (status) => {
    const name = statuses_hash[status];
    return name ? name : '未定义类别';
};
const statuses_color_hash = Object.assign(...util.statuses.map(obj => ({ [obj.value]: obj.color_class })));
util.getStatusColorClass = (status) => {
    const color_class = statuses_color_hash[status];
    return color_class ? color_class : '';
};

util.getActionType = (action) => {
    let type_obj = {};
    switch (action) {
        case 'new':
            type_obj = {name: '新增商品', color_class: 'color-success'};
            break;
        case 'update':
            type_obj = {name: '更新商品', color_class: 'color-info'};
            break;
        case 'offline':
            type_obj = {name: '下线商品', color_class: 'color-grey'};
            break;
        case 'removed':
            type_obj = {name: '删除商品', color_class: 'color-delete'};
            break;
        default:
            type_obj = {name: '未定义动作', color_class: 'color-error'};
            break;
    }
    return type_obj;
};

const adWords = ("最、最佳、最具、最爱、最赚、最优、最优秀、最好、最大、最大程度、最高、最高级、最高端、最奢侈、最低、最低级、" +
    "最低价、最底、最便宜、史上最低价、最流行、最受欢迎、最时尚、最聚拢、最符合、最舒适、最先、最先进、最先进科学、最后、最新、" +
    "最新技术、最新科学、第一、中国第一、全网第一、销量第一、排名第一、唯一、第一品牌、NO.1、TOP1、独一无二、全国第一、遗留、" +
    "一天、仅此一次、仅此一款、最后一波、全国X大品牌之一、销冠、国家级、国际级、世界级、千万级、百万级、星级、5A、甲级、超甲级、" +
    "顶级、顶尖、尖端、顶级享受、高级、极品、极佳、绝佳、绝对、终极、极致、致极、极具、完美、绝佳、极佳、至、至尊、至臻、臻品、" +
    "臻致、臻席、压轴、问鼎、空前、绝后、绝版、无双、非此莫属、巅峰、前所未有、无人能及、顶级、鼎级、鼎冠、定鼎、完美、翘楚之作、" +
    "不可再生、不可复制、绝无仅有、寸土寸金、淋漓尽致、无与伦比、唯一、卓越、卓著、前无古人后无来者、绝版、珍稀、臻稀、稀少、" +
    "绝无仅有、绝不在有、稀世珍宝、千金难求、世所罕见、不可多得、空前绝后、寥寥无几、屈指可数、独家、独创、独据、开发者、缔造者、" +
    "创始者、发明者、首个、首选、独家、首发、首席、首府、首选、首屈一指、全国首家、国家领导人、国门、国宅、首次、填补国内空白、" +
    "国际品质、黄金旺铺、黄金价值、黄金地段、金钱、金融汇币图片、外国货币、大牌、金牌、名牌、王牌、领先上市、巨星、著名、掌门人、" +
    "至尊、冠军、王、之王、王者楼王、墅王、皇家、世界领先、遥遥、领先、领导者、领袖、引领、创领、领航、耀领、史无前例、前无古人、" +
    "永久、万能、百分之百、特供、专供、推荐、专家、专家推荐、领导人、领导人推荐、点击领奖、恭喜获奖、全民免单、点击有惊喜、点击获取、" +
    "点击转身、领取奖品、抽奖、售罄、售空、再不抢就没了、史上最低价、不会再便宜、没有他就xx、错过不再、错过即无、错过就没机会了、" +
    "未曾有过的、万人疯抢、全民疯抢、抢购、免费领、免费住、0首付、免首付、零距离、价格你来定、学校名称、升学、教育护航、九年制教育、" +
    "一站式教育、入住学区房、优先入学、12年教育无忧、全程无忧、让孩子赢在起跑线上、承诺户口、蓝印户口、承诺移民、买个房啥都解决了、" +
    "上风上水、聚财纳气、宝地、圣地、府邸、龙脉、贵脉、东西方神话人物、龙脉之地、风水宝地、天人合一、堪舆、帝都、皇城、皇室领地、皇家、" +
    "皇室、皇族、殿堂、白宫、王府、府邸、皇室住所、政府机关、行政大楼、贵族、高贵、隐贵、上流、层峰、富人区、名门、阶层、阶级、升值价值、" +
    "价值洼地、价值天成、千亿价值、投资回报、众筹、抄涨、炒股不如买房、升值潜力无线、买到即赚到、直达家门口、地铁上盖、咫尺地铁站、万亩公园、" +
    "几大商场环绕、万达在旁、机场辐射区、超市、商场、学校、CBD坐标、CBD核心、城市核心地段、你在城心、我在你心、中央、中心、重心、中枢、" +
    "重点、腹地、地标、城市中央、凌驾于世界之上、几天几夜、倒计时、趁现在、就、仅限、周末、周年庆、特惠趴、购物大趴、闪购、品牌团、随时结束、" +
    "随时涨价、马上降价、国旗、国徽、国歌、第一、第二、首家、三甲、十强、国家级、世界级、最高级、最佳、最大、第一、唯一、首个、最好、最大、" +
    "精确、顶级、最高、最低、最具、最新技术、最先进科学、国家级产品、最便宜、最新、最先进、最大程度、最填补国内空白、绝对、独家、首家、最新、" +
    "第一品牌、金牌、优秀、最先、顶级、独家、全网销量第一、全球首发、全国首发、世界领先、顶级工艺、最新科学、最新技术、最先进加工工艺、最时尚、" +
    "极品、终极、顶尖、最受欢迎、王牌、冠军、第一、NO.1、Top1、top.1、NO1、NO-1、极致、永久、王牌、掌门人、领袖品牌、独一无二、绝无仅有、" +
    "前无古人、史无前例、万能、仅此、一流、保证、纯、预防、效果、超越、再也、前列、认定、超赚、极致、优秀、优质").split(/[、 ]/);
util.illegalWords = (str) => {
    const text = str.toString().toLowerCase();
    const illegalWords= [];
    adWords.forEach(function(x) {
        x = x.toLowerCase();
        if(text.indexOf(x) >= 0 && illegalWords.indexOf(x) < 0)
        {
            illegalWords.push(x);
        }
    });
    return illegalWords;
};

util.new_mall_online_sub_item = {
    platform: '',
    title: '',
    tmall_title: '',
    tmall_name: '', //天猫产品名称
    price: '',
    inner_name: '',
    remain: 0,
    // url_image: '/image/items/m/uploads/1489136683903.jpg',
    url_image: '',
    stock_group: '',
    book_name: '',
    book_isbn: '',
    book_suit: false,
    book_author: '',
    book_publisher: '',
    book_multi: false,
    book_front_image: '',
    book_barcode_image: '',
    book_copyright_image: '',
    extra_info: '',
    status: 1
};
util.new_mall_online_item = {
    apply_user_id: 0,
    apply_user: '',
    fill_user_id: 0,
    fill_user: '',
    platforms: '',
    platform_list: [],
    channel_id: '',
    title: '',
    formal_title: '',
    short_name: '', //商城内部简称（商家编码）
    desc: '',
    // image_small: '/image/items/m/uploads/1569661222697.jpg',
    image_small: '',
    // image_normal: '/image/items/m/uploads/1569661262745.jpg;/image/items/m/uploads/1569661285082.jpg;/image/items/m/uploads/1569661329278.jpg;/image/items/m/uploads/1569661336568.jpg',
    image_normal: '',
    // description: '<img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/6db628d7c390.jpg" alt="" /><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/e31de7d154ca.jpg" alt="" /><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/e73465acad73.jpg" alt="" /><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/d679d4aaf0cf.jpg" alt="" /><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a5bbdf9a28ed.jpg" alt="" /><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/8b722b00e70e.jpg" alt="" /><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/2421e387d7d0.jpg" alt="" /><a href="http://mall.baicizhan.com/m/item?id=2002200"><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a0d53f2c713b.jpg" alt="" /></a><a href="http://mall.baicizhan.com/m/item?id=2002201"><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/635c64031b68.jpg" alt="" /></a><a href="http://mall.baicizhan.com/m/item?id=2002202"><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a4cb7685ca7f.jpg" alt="" /></a><a href="http://mall.baicizhan.com/m/item?id=2002199"><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/339db88b703b.jpg" alt="" /></a><a href="http://mall.baicizhan.com/m/item?id=2003374"><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/34b6a2bd993e.jpg" alt="" /></a><a href="http://mall.baicizhan.com/m/item?id=2003372"><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/f313369a7cef.jpg" alt="" /></a><a href="http://mall.baicizhan.com/m/item?id=2003371"><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/872348f82dbf.jpg" alt="" /></a><a href="http://mall.baicizhan.com/m/item?id=2003370"><img src="http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/0d166b3c3e84.jpg" alt="" /></a>',
    description: '',
    category_id: '',
    item_type: 0,
    show_type: 0,
    extra_tag: '',
    display_url: '',
    notify_url: '',
    jump_url: '',
    third_md5_key: '',
    free_postage: false,
    sale_time: '',
    auto_refund_deadline: '',
    extra_info: '{}',
    status: 1,
    taobao_title: '',
    taobao_short_name: '', //淘宝内部简称（商家编码）
    mall_sub_items: [Util.clone(util.new_mall_online_sub_item)],
    taobao_sub_items: [Util.clone(util.new_mall_online_sub_item)],
    tmall_sub_items: [Util.clone(util.new_mall_online_sub_item)],
    short_description: "",
    pledge_tag_ids: [],
    video_url: "",
    video_cover_url: "",
};
// 平台
util.platforms = [
    {
        value: 'mall',
        label: '百词斩商城',
    },
    {
        value: 'taobao',
        label: '淘宝',
    },
    {
        value: 'tmall',
        label: '天猫',
    },
];
const platform_hash = Object.assign(...util.platforms.map(obj => ({ [obj.value]: obj.label })));
util.getPlatformName = (platform) => {
    let platforms = platform.split(",")
    let name = ""
    for (let i=0; i < platforms.length; i++){
        //alert(platform_hash[platforms[i]])
        if (name != ""){
            name = name + "," + platform_hash[platforms[i]];
        } else {
            name = platform_hash[platforms[i]];
        }    
    }
    return name ? name : '未定义平台';
};

util.diffArray = (platforms) =>{
    let a = platforms;
    let exists = ["mall","tmall","taobao"];
    let c = [];
    let tmp = a.concat(exists);
    let o = {};
    for (let i = 0; i < tmp.length; i ++) (tmp[i] in o) ? o[tmp[i]] ++ : o[tmp[i]] = 1;
    for (let x in o) if (o[x] == 1) c.push(x);
    return c;
};

export default util;
